import { BCAlert, IAlertTypes } from '@bimser/components';
import * as React from 'react';
import Styles from '../assets/styles.scss';
import { ISummaryMessage, ISummaryMessagesProps } from '../entities';

export function SummaryMessages({ messages, onSummaryMessageClose }: ISummaryMessagesProps) {
	const getAlertType = (
		type: 'Success' | 'Error' | 'Warning' | 'Info' | 'Blocked' | 'SevereWarning'
	): IAlertTypes => {
		switch (type) {
			case 'Success':
				return IAlertTypes.success;
			case 'Error':
				return IAlertTypes.error;
			case 'Info':
				return IAlertTypes.info;
			case 'Warning':
				return IAlertTypes.warning;
			case 'SevereWarning':
				return IAlertTypes.warning;
			case 'Blocked':
				return IAlertTypes.error;
		}
	};

	const onClose = (message: ISummaryMessage) => {
		onSummaryMessageClose?.(message.title);
	};

	const renderMessage = (message: ISummaryMessage) => (
		<BCAlert
			key={message.title}
			message={message.title}
			description={message.message}
			type={getAlertType(message.type)}
			className={[Styles.summaryMessageItem, message.type?.toLocaleLowerCase()].join(' ')}
			onClose={e => {
				e.event.stopPropagation();
				onClose(message);
			}}
			closable
		/>
	);

	const getMessages = () =>
		messages ? messages.map(message => renderMessage(message)) : undefined;

	return <div className={Styles.summaryMessages}>{getMessages()}</div>;
}
